import type { SVGProps } from 'react';
export const SvgMail = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			stroke="#AAA"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="m2.5 6.666 6.576 4.384c.56.373 1.289.373 1.848 0L17.5 6.666M4.167 15.833h11.666c.92 0 1.667-.747 1.667-1.667V5.833c0-.92-.746-1.667-1.667-1.667H4.167c-.92 0-1.667.746-1.667 1.667v8.333c0 .92.746 1.667 1.667 1.667"
		/>
	</svg>
);
